import { AlertService } from './services/AlertService';
import type { Init } from './types';
import type { MergedDataReturnType, MergedHandlersReturnType } from '../../types';
import type { WidgetLifecycle } from '../WidgetLifecycle';
import { WithApi } from '../WithApi';

export type AlertData = MergedDataReturnType<[AlertService]>;

export type AlertHandlers = MergedHandlersReturnType<[AlertService]>;

type TApi = ReturnType<AlertService['api']>;

export class AlertManager extends WithApi<TApi> {
  public alertInit = ({ pageStore, locationState }: Init) => {
    const alertService = new AlertService(pageStore);

    this.initApi({
      ...alertService.api(),
    });

    return {
      status: 'loaded',
      data: {
        ...alertService.data(),
      },
      handlers: {
        ...alertService.handlers(),
      },
      lifecycle: {
        onMount() {
          alertService.onMount(locationState);
        },
      } satisfies WidgetLifecycle,
    } as const;
  };
}
